module.exports = __webpack_public_path__ + "static/petits-panettones-bdb385d6e4a3632bc0fae48e36bcf704.jpg";